import { render } from "./ClientsDevice.vue?vue&type=template&id=5f765b5a"
import script from "./ClientsDevice.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientsDevice.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script